import * as LabelPrimitive from "@radix-ui/react-label";
import {
	type ComponentPropsWithoutRef,
	type ElementRef,
	forwardRef,
} from "react";
import { cn } from "../lib/cn";

export interface AtomLabelProps
	extends ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {}

const AtomLabel = forwardRef<
	ElementRef<typeof LabelPrimitive.Root>,
	AtomLabelProps
>(({ className, ...props }, ref) => (
	<LabelPrimitive.Root
		ref={ref}
		className={cn(
			"text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
			className,
		)}
		{...props}
	/>
));
AtomLabel.displayName = "AtomLabel";

export default AtomLabel;
export { AtomLabel };
